export const URLS = {
  BACKEND_URL: '',
  FRONTEND_URL: ''
}
